import { CardDetail, Container, Title } from '@/components'
import Image from 'next/image'
import FgtIconPink from '/public/images/fgt-pink.webp'
import { PLAY, PLAY_AOVIVO } from '@/constants/plansCompare'

import styles from './styles.module.scss'

const PlansCompare = ({ setOpenModal, onPlanSelected }) => {
  return (
    <section className={`fgt-section ${styles.plansCompare}`} id="comparePlans">
      <Container classname={styles.container}>
        <Title Tag="h2" variant="light" alignText="center" colorText="pink">
          COMECE AGORA E <span>EXPERIMENTE POR 7 DIAS</span>
        </Title>
        <p className={`fgt-subtitle ${styles.subtitle}`}>
          Acesse <strong>TREINOS AO VIVO</strong> e gravados. Invista na sua
          saúde com os treinos da Academia Foguete.
        </p>

        <div className={styles.cardsDetails}>
          <CardDetail
            plan={PLAY}
            actionButton={() => {
              setOpenModal(true)
              onPlanSelected(PLAY.id)
            }}
          />
          <CardDetail
            plan={PLAY_AOVIVO}
            variant="pink"
            actionButton={() => {
              setOpenModal(true)
              onPlanSelected(PLAY_AOVIVO.id)
            }}
            disclaimer={
              <div className={styles.disclaimer}>
                <Image
                  src={FgtIconPink}
                  alt="Foguete Icon"
                  width={24}
                  height={24}
                />{' '}
                <p>Você só encontra na Academia Foguete</p>
              </div>
            }
          />
        </div>
      </Container>
    </section>
  )
}

export default PlansCompare
